<template>
  <PublicPopup ref="PopupRef" :closeable="false">
    <template #content>
      <div class="maintain-popup">
        <div class="images-box">
          <!-- <img src="" alt=""> -->
        </div>
        <div class="desc">
          <p>{{ $t('home-ad-popup-maintain-popup.line1') }}</p>
          <p>{{ $t('home-ad-popup-maintain-popup.line2') }}</p>
          <p>{{ $t('home-ad-popup-maintain-popup.line3') }}</p>
          <p>{{ $t('home-ad-popup-maintain-popup.line4') }}</p>
          <p>{{ $t('home-ad-popup-maintain-popup.line5') }}</p>
          <p>{{ $t('home-ad-popup-maintain-popup.line6') }}</p>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.maintain-popup {
  height: 60vh;
  overflow-y: auto;

  .images-box {
    height: 200px;
  }

  .desc {
    font-size: 14px;
    color: var(--maintain-popup-content-text);
    line-height: 1.5;
  }
}
</style>
